/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_MissingInputs */

const en_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No video file selected`)
};

const fr_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun fichier vidéo sélectionné`)
};

const de_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Videodatei ausgewählt`)
};

const it_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun file video selezionato`)
};

const ru_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеофайл не выбран`)
};

const es_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún archivo de vídeo seleccionado`)
};

const zh_cn2_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择视频文件`)
};

const ja_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオファイルが選択されていません`)
};

const hi_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई वीडियो फ़ाइल चयनित नहीं है`)
};

const pt_pt2_audio_description_export_video_missing = /** @type {(inputs: Audio_Description_Export_Video_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum arquivo de vídeo selecionado`)
};

/**
* | output |
* | --- |
* | "No video file selected" |
*
* @param {Audio_Description_Export_Video_MissingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_missing = /** @type {((inputs?: Audio_Description_Export_Video_MissingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_MissingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_video_missing(inputs)
	if (locale === "de") return de_audio_description_export_video_missing(inputs)
	if (locale === "it") return it_audio_description_export_video_missing(inputs)
	if (locale === "ru") return ru_audio_description_export_video_missing(inputs)
	if (locale === "es") return es_audio_description_export_video_missing(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_video_missing(inputs)
	if (locale === "ja") return ja_audio_description_export_video_missing(inputs)
	if (locale === "hi") return hi_audio_description_export_video_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_video_missing(inputs)
	return en_audio_description_export_video_missing(inputs)
});